export default __webpack_public_path__ + "static/media/OIM.af211c60.svg";